// import Category from './Category';

export default {
  // component: Category,
  component: load(() => import(/* webpackChunkName: "Bulletin-Category" */ './Category')),
  priority: 9,
  permissions: ['PortalMenu/CategoriesMenuPost'],
  name: app.translate('routes.home.bulletin.Category'),
  icon: 'tag',
  drawer: true,
};


